export enum BehaviorCompletionSource {
  Import = 'import',
  Manual = 'manual',
}
